import { Component, OnInit } from '@angular/core';
import { TramitesService } from 'src/app/servicios/tramites.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { Loading } from 'src/app/Class/Loading';
import { Mensajes } from 'src/app/Class/mensajes';

@Component({
  selector: 'app-solicitud',
  templateUrl: './solicitud.component.html',
  styleUrls: ['./solicitud.component.css']
})
export class SolicitudTramiteComponent implements OnInit {
  public serve : any;
  public tipo_id_selected: number;
  public data: any= {};
  public tiposdocumentos: any= [];
  public programas: any= [];
  public gratuito: any;

  
  //public tipos_tramite: any = [];
  public solicitud_tramite: FormGroup;

  constructor(private tramiteService: TramitesService, private form: FormBuilder, private rout: ActivatedRoute, private route: Router, public loading: Loading) { 
    this.loading.estado=true;
    
    this.rout.params.subscribe(params => {
      this.tipo_id_selected = params['id'];
      this.tramiteService.getTipoTramite(this.tipo_id_selected).subscribe(data => {
        if(data['success']){
          this.data  = data['data'],
          this.gratuito = data['data']['gratuito'],
          this.programas = data['data']['programas'],
          this.tiposdocumentos = data['data']['tipos_doc']
          this.solicitud_tramite.get('tipo_id_selected').setValue(this.tipo_id_selected);
          this.loading.estado=false;
        }else{
          Swal.fire({ type: 'error', title:'Error',  text: 'Trámite no disponible',  showConfirmButton: false, timer: 1500 });
          this.loading.estado=false;
          this.route.navigate(['/dashboard']);
        }
      });
    });

    this.serve = this.tramiteService.getServe();
    //this.datosSelect();
    this.solicitud_tramite = this.form.group({
      nombre:  ['', Validators.required],
      apellidos:  ['', Validators.required],
      documento_identificacion:  ['', Validators.required],
      tipo_doc_id:  ['', Validators.required],
      email:  ['', Validators.required],
      direccion:  ['', Validators.required],
      telefono:  ['', Validators.required],
      tipo_id_selected: ['', Validators.required],
      soporte: ['', Validators.required],
      observacion: [''],
      programa: [''],
      numero_acta_res:[''],
      fecha_grado_res:['']
    });
    
    
    
  }

  ngOnInit() {
  }

  // datosSelect(){

  //   this.tramiteService.getDatosSolicitud()
  //   .subscribe(data => 
  //   {      
  //     this.tipos_tramite = data['data']['tipo_tramite'];
  //   });  
  // }
  
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.solicitud_tramite.get('soporte').setValue(file);
    }
  } 
  
  guardarTramite() {    
    debugger;
    var formData = new FormData();
    if (!this.solicitud_tramite.valid) {
      Swal.fire({ type: 'error', title:'Error', text: 'Verifique los datos e intente nuevamente', showConfirmButton: false, timer: 1500 });
    }    
    else{
      this.loading.estado = true;
      for( var nombre in this.solicitud_tramite.value ) { 
        
        // if(nombre == "programa"||nombre =="tipo_doc_id"){
        //   for(var j=0; j<this.solicitud_tramite.value[nombre].length;j++){
        //     formData.append(nombre+'[]', this.solicitud_tramite.value[nombre][j]); 
        //   }
        // }
        // else{
          formData.append(nombre, this.solicitud_tramite.value[nombre]); 
        // }
      }
     
      this.tramiteService.guardarSolicitud(formData)
      .subscribe(data => {
        if(data['success'] == true){
          Swal.fire({ type: 'success', title: Mensajes.guardar.titulo, showConfirmButton: false, timer: 1500 });
          this.route.navigate(['/perfilUsuario']);
        }
        else{
          Swal.fire({ type: 'error', title:'Error', text: 'Los datos no fueron ingresados', showConfirmButton: false, timer: 1500});
        }
        this.loading.estado = false;      
      });
    }
  }
}
